<template>
  <div class="main">

    <!-- <section class="pl-f-b2b-product-category-hero pl-spacer pl-spacer--in--large pl-spacer--cut-h pl-bg pl-bg--white">
      <div class="container">
        <div class="row">
          <div class="col-xs-10 col-xs-offset-1 col-lg-12 col-lg-offset-0 pl-lockup text-center ">
            <h1 class="pl-h1 pl-color--black">{{ content.title }}</h1>
            <p class="pl-text pl-text--large">{{ content.subtitle }}</p>
          </div>
        </div>
      </div>
    </section> -->

    <bannertitle>
      <template slot="title">{{ content.title }}</template>
      <template slot="subtitle">{{ content.subtitle }}</template>
    </bannertitle>

    <div v-for="(block, index) in content.blocks"
         v-bind:key="index"
         :class="index%2>0? 'pl-bg pl-bg--white-lighter'  :'pl-bg pl-bg--gray-lighter'">
      <section class="f-b2b-product-category-two-columns-left pl-spacer pl-spacer--cut-left pl-spacer--cut-right pl-spacer--out--small pl-spacer--cut-v pl-color pl-bg pl-color pl-color--white">
        <div class="f-b2b-product-category-two-columns-right__container container container-fluid f-pro-container-large f-pro-parallax-hero--flex">
          <div style="padding:0 10%"
               :style="{'order': index%2>0? '3'  :'1'}"
               :class="index%2>0? 'padding-odd':'padding-even'"
               class="f-pro-parallax__flex-item f-b2b-product-category-two-columns-left--text-column pl-spacer--in--small margin-bottom-20">
            <div id="f-pro-parallax-text"
                 class="f-pro-parallax-hero__text">
              <!-- <span class="pl-f-b2b-product-category-hero__tag  pl-tag">{{ block.tag }}</span> -->
              <h2 class="pl-h2  pl-color--black">
                <span class="pl-color">
                  <a :href="block.link_url"
                     target="_self"
                     data-Tealiumevent="generic"
                     v-bind:data-Tealiumeventmetadata="block.title">{{ block.title }}</a>
                </span>
              </h2>
              <p class="pl-hr--flat pl-color pl-color--gray-darkest"
                 style="max-height:275px;overflow:hidden">{{ block.subtitle }}</p>
              <p class="pl-text pl-text--medium pl-color--blue">
                <a :href="block.link_url"
                   data-Tealiumevent="generic"
                   v-bind:data-Tealiumeventmetadata=block.link_title
                   class="f-b2b-product-category-two-columns-right__link pl-link pl-link--fwd "
                   target="_self">{{ block.link_title }}<i aria-hidden='true'></i></a>
              </p>
            </div>
          </div>
          <div :class="index%2>0? 'padding_left'  :'padding_right'"
               class="f-pro-parallax__flex-item f-b2b-product-category-two-columns-right--picture-column">
            <img v-bind:src="getImagePath(block.image)"
                 v-bind:alt="block.image_alt"
                 class="f-b2b-product-category-two-columns-right__image pl-amplience__image" />
          </div>
        </div>
      </section>
    </div>

    <!-- <section class="bottom_button_section">
      <div class="text_align">
        <h2 class="">{{content.contact_text}}</h2>
        <br>
        <a href="mailto:enquiry@cbsg.canon.com.cn"
           class="pl-btn--medium">{{content.contact_button}}</a>
      </div>
    </section>
    <div class="thirdinfo">
      <div class="thirdinfo__list">•  价格、规格、供货情况及使用条款如有更改，恕不另行通知。</div>
      <div class="thirdinfo__list">•  产品/服务可能由第三方制造商/供应商制造及/或提供予我们用于分销/转售 (非佳能品牌之产品/服务)。</div>
      <div class="thirdinfo__list">•  以上价格为人民币建议零售价，如有更改，恕不另行通知。</div>
    </div>-->
    <learnmore :option="learn_option">
      <template slot="line_two">{{content.contact_text}}</template>
      <template slot="learn_more_button">{{content.contact_button}}</template>
    </learnmore>
  </div>
</template>

<script>
import contents from '../json/contents.json'
import learnmore from './LearnMore'
import bannertitle from './Article/bannertitle'

export default {
  name: 'Main',
  components: {
    bannertitle, learnmore
  },

  props: [
    'belongTo'
  ],

  data () {
    return {
      content: '',
      learn_option: {
        backgroundColor: '#505050',
        fontColor: 'white'
      }
    }
  },

  methods: {
    getImagePath (name) {
      var images = require.context('../assets/FFP/images/', true, /\.png$/)
      console.log(images('./banner.png'))
      return name ? images(name) : ''
    }
  },

  mounted () {
    // this.content = contents.solutions_main
    var page = this.belongTo + '_main'
    console.log('Page: ' + page)
    this.content = contents[page]
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='../assets/FFP/css/Main.css'></style>



// WEBPACK FOOTER //
// src/components/Main.vue